import React from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Stack,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import DyTextField from "../GlobalComponents/DyTextField/DyTextField";
import okr from '../../SidebarIcons/logo512.png'; 
import DyButton from "../GlobalComponents/DyButton/DyButton";
import LyBackdrop from "../Layouts/BackDrop/BackDrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setUserPhoneNumberR } from "../Login/LoginSlice/LoginSlice";
import { useState, useEffect } from "react";
import Progress from '../Progress/Progress';
import BackGround from '../Login/Statics/Imgs/bg3.png'
import { useSelector } from "react-redux";
import {ReactComponent as Img2} from '../Loading/svg/MainLogoOKR.svg';
// import {ReactComponent as OKRText} from '../Loading/svg/OKRText.svg';
import OKRText from '../../SidebarIcons/OKRText.svg'; 
import SideBarLogo from "../Dashboard/StaticsData/SVG/SideBarLogo.svg"; 
import { useLogin } from "../Login/Hooks/Index";
import useWindowDimensions from "../DeviceSize/DeviceSize";
import AndroidIcon from "@mui/icons-material/Android";
import DYToastMessage from "../GlobalComponents/DyToastMessage/DYToastMessage";
import "./Style.css";
import SchoolIcon from "@mui/icons-material/School";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import HandshakeIcon from "@mui/icons-material/Handshake";
import SportsIcon from "@mui/icons-material/Sports";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import Divider from "@mui/material/Divider";
import { useDispatch } from "react-redux";
import { resetMeetingSliceR } from "../../scenes/Meeting/MeetingsSlice/MeetingsSlice";
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff'
const LoginForm = ({ setContentState }: any) => {
  const { width } = useWindowDimensions();
  const [loginStatusLocal, setLoginStatusLocal] = useState<boolean | null>(
    null
  );
  const [loginMessage, setLoginMessage] = useState<string | null>(null);
  let authDevice = width > 900;
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const loginStatus: any = useSelector((state: any) => state.loign.loginStatus);
  const dispatch = useDispatch();
  // const userInfo:any=useAppSelector(state=>state.loign.userInfo.userPhoneNumber)
  const loginSuccess = () => {
    // navigate('/dashboard',{replace:true})
    // console.log(logdata)
    // if (loginStatus?.hasOwnProperty('accessToken')) {
    setContentState((prev: any) => ({ ...prev, content: "userTypeSelection" }));
    // }
  };

  useEffect(() => {
    let initialValues = {
      priodId: "",
      periodName: "",
      meetingId: "",
      profileTenantId: "",
      teamId: "",
      profileName: "",
      periodList: [],
      meetingsList: null,
      teamsData: [],
      teamInfo: {},
      companyList: [],
      teamList: [],
      objectivie: [],
      keyResults: [],
      loading: false,
      objUpdated: false,
      changeTenantMode: false,
      meetSelectedDate: "",
      pictureBase64String: "",
      treeViewState: {
        treeView: true,
      },
      counter: 0,
    };
    dispatch(resetMeetingSliceR(initialValues));
  });

  const loginFailed = () => {};
  const {
    data: logdata,
    mutate: LoginReq,
    isLoading,
  } = useLogin(loginSuccess, loginFailed);

  const userBody = {
    phoneNumber: "",
    password: "",
    smsCode: "",
    isOTP: false,
  };

  const initialValue = {
    phoneNumber: "09198390527",
    password: "AriaBarbod",
  };
  const [userInfoState, setUserInfoState] = useState<any>(userBody || null);

  // console.log(logdata)

  const initialForgetPass = () => {
    // console.log('runnn')
    setContentState((prev: any) => ({ ...prev, content: "forgetPassWord" }));
  };

  const loginHandler = () => {
    LoginReq(userInfoState);

    dispatch(setUserPhoneNumberR(userInfoState || ""));
    // console.log(userInfoState)
  };
  // const handleChange = (e:any) => setUserInfoState({ ...userInfoState, [e.target.name]: e.target.value });
  const convertPersianToEnglish = (input: string) => {
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    return input.replace(/[۰-۹]/g, (match) => englishNumbers[persianNumbers.indexOf(match)]);
};
interface Props {
  userInfoState: { phoneNumber: string };
  setUserInfoState: React.Dispatch<React.SetStateAction<{ phoneNumber: string }>>;
}
  const handleChange = (e: any) => {
    const value = e.target.value;
    const englishValue = convertPersianToEnglish(value);
    setUserInfoState({ ...userInfoState, [e.target.name]: englishValue });
};
  useEffect(() => {
    if (logdata) {
      // console.log(logdata)
      let {
        data: { isSuccess, data, metaData },
      }: any = logdata;
      let { message }: any = metaData;
      let logStatus = { success: isSuccess };
      // console.log(message)
      setLoginMessage(message);
      // loginMessage,setLoginMessage
      setLoginStatusLocal(!loginStatus);
      // console.log(isSuccess, data)
    }
  }, [logdata]);

  // const linkStyle = {
  //   fontSize: "0.6rem",
  // };
 
const linkStyle = {
  fontSize: '10px',
  fontWeight: 500,
  textAlign: 'center',
};
 

  const initialChangePass = () => {
    setContentState((prev: any) => ({ ...prev, content: "resetPassword" }));
    //console.log("initialChangePass");
  };

  const initialTenantRegister = () => {
    setContentState((prev: any) => ({ ...prev, content: "registerTenant" }));
    // console.log("registerTenant");
  };

  const initialRegisterByCode = () => {
    setContentState((prev: any) => ({ ...prev, content: "registerByCode" }));
    // console.log("registerByCode");
  };

  const initialRegisterTenant = () => {
    setContentState((prev: any) => ({ ...prev, content: "RegisterTenant" }));
    // console.log("RegisterTenant");
  };

  if (isLoading) {
    return (
      <LyBackdrop visible={true}>
        <CircularProgress sx={{ color: "white" }} />
      </LyBackdrop>
    );
  }

  return (
    <Grid container
  direction={{ xs: "column", md: "row" }} // برای موبایل عمودی و برای وب افقی
  alignItems="center"
  justifyContent="center"
  sx={{
    bgcolor: { xs: "#00387C", md: "transparent" }, // رنگ بک‌گراند برای موبایل و دسکتاپ
    padding: { xs: 0.5, md: 0 }, // فقط در موبایل
    position: { xs: "fixed", md: "static" }, // فقط در موبایل
    margin: { xs: 0, md: "initial" }, // فقط در موبایل
    minHeight: '100vh', // ارتفاع حداقلی کانتینر به اندازه کل صفحه
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow:'auto',
    
  }}

>
<Grid 
  item 
  xs={12} 
  // width={"300px"}
  // height={"20px"}
  sx={{ 
    // minHeight: '100vh', // ارتفاع حداقلی کانتینر به اندازه کل صفحه
    // display: 'flex',
    // justifyContent: 'center',
    alignItems: 'center',
    display: { xs: 'flex', md: 'none' }, // در موبایل نمایش به صورت flex
    flexDirection: 'row', // تصاویر کنار هم قرار می‌گیرند
    justifyContent: 'center', // وسط‌چین کردن تصاویر
    textAlign: 'center',
    padding:2,
    borderRadius:2, 
    // marginBottom:1,
    height:"10px",
    gap: '10px', // فاصله بین تصاویر
    bgcolor:"#00387C"
  }}
>
  <img src={SideBarLogo} style={{ width: 82, height: 82 }} />
  <img src={OKRText} style={{ width: 100, height: 82 }} />
</Grid>


  <Grid
    item
    xs={12}
    md={9.1}
    sx={{
      bgcolor: 'white',
      borderRadius: 8,
      boxShadow: '0 12px 36px rgba(0, 0, 0, 0.25)',
      padding: { xs: 3, sm: 4, md: 5 },
      width: { xs: '90%', sm: '400px', md: 'auto' },
      maxWidth: '400px',
      maxHeight: '90vh',
      minHeight: '300px',
      transition: 'all 0.4s ease-in-out',
      transform: 'scale(1)',
      '&:hover': {
        boxShadow: '0 12px 36px rgba(0, 0, 0, 0.25)',
        transform: 'scale(1.03)',
      },
    }}
  >


        <Grid container rowGap={1}>
        <Grid item xs={12}>
            <Typography
              px={4}
              fontWeight={900}
              fontSize={"1.5rem"}
              color={"#00387C"} // تغییر به رنگ مناسب
              sx={{
                p: 2, // کاهش padding برای متن اول
                mb: 1, // افزودن margin-bottom برای فاصله بین دو متن
              }}
              textAlign={"left"}
            >
              {/* متن اصلی در اینجا قرار می‌گیرد */}
              {/* مثلاً: "عنوان اصلی" */}
            </Typography>
            <Typography
              marginLeft={2}
              fontSize={"1rem"} // سایز فونت کوچکتر
              fontWeight={600}
              sx={{ marginTop: '-15px' }} // بالا بردن متن
              color={"#555"} // رنگ متن ثانویه
            >
              برای ورود شماره همراه خود را وارد کنید
            </Typography>
          </Grid>


          <Grid item xs={12}>
            <Grid container px={3}>
              <Grid item xs={12} my={1} display={"flex"} alignItems={"center"}>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} px={6} >
            <form autoComplete="off">
              <Grid container>
              <Grid item xs={11} mx="auto">
            <FormControl fullWidth variant="outlined">
                <TextField
                    label="شماره موبایل"
                    variant="outlined"
                    value={userInfoState.phoneNumber}
                    onChange={handleChange}
                    size="small"
                    name="phoneNumber"
                    inputProps={{ maxLength: 11 }}
                    sx={{ borderRadius: 5, bgcolor: '#f9f9f9' }}
                    InputLabelProps={{ shrink: true }} // Ensure label stays in place
                />
            </FormControl>
            </Grid>


            <Grid item xs={11} py={3} mx="auto">
            <FormControl fullWidth variant="outlined">
              <TextField
                label="رمز عبور"
                variant="outlined"
                value={userInfoState.password}
                onChange={handleChange}
                name="password"
                size="small"
                type={showPassword ? 'text' : 'password'}
                inputProps={{ maxLength: 200 }}
                sx={{ borderRadius: 5, bgcolor: '#f9f9f9' }}
                InputLabelProps={{ shrink: true }} // Ensure label stays in place
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="medium"
                        color="primary"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </Grid>

                <Grid item xs={8} mx={"auto"}>
                <Box py={1} gap={'30px'} display={'flex'} flexDirection={'row-reverse'} justifyContent={'start'}>
                  <DyButton
                      caption={'ثبت نام با کد دعوت'}
                      onClick={initialRegisterByCode}
                      variant={'contained'}
                      bgColor={'#00387C'}
                      color={'#fff'}
                    />

                    <DyButton
                      caption={'ورود'}
                      onClick={loginHandler}
                      disbled={userInfoState.phoneNumber.length < 11}
                      variant={'contained'}
                      bgColor={'#00387C'}
                      type={'submit'}
                    />
                     </Box>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Box
                    py={3}
                    display={"flex"}
                    flexDirection={{ xs: "column", md: "row" }} // استفاده از ستون در موبایل
                    justifyContent={"space-between"}
                  >
                    {/* <Box
                      display={"flex"}
                      flexDirection={"row-reverse"}
                      justifyContent={"center"} // تغییر به مرکز برای قرارگیری خط زیر دکمه
                      sx={{   
                        border: '2px solid #00387C',
                        borderRadius: 8,
                        '&:hover': {
                          boxShadow: '0 12px 36px rgba(0, 56, 124, 0.3)',
                          transform: 'scale(1.03)', // کمی بزرگ‌تر شدن المان در هاور
                        }
                       }} // برای مدیریت خط زیر دکمه
                    >
                      <DyButton
                        caption={"ثبت نام با کد دعوت"}
                        onClick={initialRegisterByCode}
                        variant={"text"}
                      />
                    </Box> */}
                  <Box
                      display={"flex"}
                      flexDirection={"row-reverse"}
                      justifyContent={"space-between"}
                      sx={{   
                        border: '2px solid #00387C',
                        borderRadius: 8,
                        '&:hover': {
                          boxShadow: '0 12px 36px rgba(0, 56, 124, 0.3)',
                          transform: 'scale(1.03)', // کمی بزرگ‌تر شدن المان در هاور
                        }
                       }} // برای مدیریت خط زیر دکمه
                    >
                      <DyButton
                        caption={"ثبت نام شرکت"}
                        onClick={initialTenantRegister}
                        variant={"text"}
                        type={"submit"}
                        fontSize={10}
                      />
                    </Box> 
                    <Box
                      display={"flex"}
                      flexDirection={"row-reverse"}
                      justifyContent={"space-between"}
                      sx={{   
                        border: '2px solid #00387C',
                        borderRadius: 8,
                        '&:hover': {
                          boxShadow: '0 12px 36px rgba(0, 56, 124, 0.3)',
                          transform: 'scale(1.03)', // کمی بزرگ‌تر شدن المان در هاور
                        }
                       }} // برای مدیریت خط زیر دکمه
                    >
                      <DyButton
                        caption={"فراموشی رمز عبور"}
                        onClick={initialChangePass}
                        variant={"text"}
                        type={"submit"}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} mt={{ xs: 1, sm: 6 }}   sx={{
    display: { xs: 'none', sm: 'block' }, // مخفی کردن در موبایل
  }} mx="auto">
                <Box
    width="100%"
    display="flex"
    justifyContent="space-between"
    textAlign="center"
    flexDirection="column"
    rowGap={1.5} // فاصله عمودی کوچکتر
    sx={{
      // تنظیمات برای موبایل
      padding: { xs: 2, sm: 4 }, // پدینگ برای موبایل کمتر و برای وب بیشتر
    }}
  >
    <Box display="flex" flexDirection="row" justifyContent="space-between">
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        columnGap={1.5} // فاصله افقی کوچکتر
        alignItems="center"
        sx={{
          flexDirection: { xs: 'row', sm: 'row' }, // در موبایل عمودی، در وب افقی
          rowGap: { xs: 1, sm: 0 }, // فاصله عمودی برای موبایل و وب
        }}
      >
        <Box>
          <a
            target="_blank"
            style={{ textDecoration: 'none' }}
            rel="noopener noreferrer"
            href="https://okrcoach.ir/okredu/"
          >
            <Typography sx={linkStyle} color="primary">
              آموزش نرم افزار
            </Typography>
          </a>
        </Box>
        <Box>
          <SchoolIcon color="primary" />
        </Box>
        <Box mt={0.5}>
          <a
            target="_blank"
            style={{ textDecoration: 'none' }}
            rel="noopener noreferrer"
            href="https://okrcoach.ir/okrcoach-software-online/"
          >
            <Typography sx={linkStyle} color="primary">
              خرید اشتراک نرم افزار
            </Typography>
          </a>
        </Box>
        <Box>
          <CreditCardIcon color="primary" />
        </Box>
        <Box>
          <a
            target="_blank"
            style={{ textDecoration: 'none' }}
            rel="noopener noreferrer"
            href="https://okrcoach.ir/okr-blog/"
          >
            <Typography sx={linkStyle} color="primary">
              مجله OKR
            </Typography>
          </a>
        </Box>
        <Box>
          <NewspaperIcon color="primary" />
        </Box>
      </Box>
    </Box>
  </Box>
  <Divider variant="middle" />
  
  <Box
    display="flex"
    flexDirection="row"
    justifyContent="space-between"
    mt={1.5} // فاصله عمودی کوچکتر
    sx={{
      flexDirection: { xs: 'column', sm: 'row' }, // در موبایل عمودی، در وب افقی
    }}
  >
    <Box
      width="100%"
      display="flex"
      justifyContent="center"
      columnGap={1.5} // فاصله افقی کوچکتر
      alignItems="center"
    >
      <Box>
        <a
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noopener noreferrer"
          href="https://okrcoach.ir/services/course/"
        >
          <Typography sx={linkStyle} color="primary">
            آموزش OKR
          </Typography>
        </a>
      </Box>
      <Box>
        <SchoolIcon color="primary" />
      </Box>
      <Box>
        <a
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noopener noreferrer"
          href="https://okrcoach.ir/amir-imenpour/"
        >
          <Typography sx={linkStyle} color="primary">
            معرفی ما
          </Typography>
        </a>
      </Box>
      <Box>
        <CoPresentIcon color="primary" />
      </Box>
      <Box>
        <a
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noopener noreferrer"
          href="https://okrcoach.ir/customers/"
        >
          <Typography sx={linkStyle} color="primary">
            مشتریان ما
          </Typography>
        </a>
      </Box>
      <Box>
        <HandshakeIcon color="primary" />
      </Box>
      <Box>
        <a
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noopener noreferrer"
          href="https://okrcoach.ir/okr-coach/"
        >
          <Typography sx={linkStyle} color="primary">
            درخواست مربی
          </Typography>
        </a>
      </Box>
      <Box>
        <SportsIcon color="primary" />
      </Box>
    </Box>
  </Box>
</Grid>


              </Grid>
            </form>
          </Grid>
        </Grid>
        

</Grid>
 <Grid>
 <Box
  sx={{
    background: '#00387C',
    padding: '5px 10px',
    borderRadius: '5px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    display: { xs: 'inline-block', md: 'none' }, // فقط برای موبایل
    marginTop: 2,
  }}
>
  <Typography color="white" fontWeight={550} fontSize="11px">
    ورژن 1.3.6
  </Typography>
</Box>
 </Grid>
      {loginStatusLocal && loginMessage && (
      <DYToastMessage
          show={!loginStatus}
          setShow={setLoginStatusLocal}
          message={loginMessage}
        />
         )}
      {/* {loginStatusLocal && loginMessage && (
        <DYToastMessage
          show={!loginStatus}
          setShow={setLoginStatusLocal}
          message={loginMessage}
        />
      )}

      <div className="dark:flex hidden">
        <DYToastMessage
          show={true}
          setShow={setLoginStatusLocal}
          message=" جهت نمایش مطلوب تر صفحات، لطفا دستگاه خود را از Dark Mode خارج نمایید."
          anchorVertival="top"
        />
      </div> */}
    </Grid>
  )
}

export default LoginForm
///////////////////////////////////////////////////////////////////////////////////////////
// import React from 'react';
// import { Box, Grid, TextField, Typography, Button, OutlinedInput, FormHelperText } from '@mui/material';
// import FormControl from '@mui/material/FormControl';
// import DyTextField from '../GlobalComponents/DyTextField/DyTextField';
// import DyButton from '../GlobalComponents/DyButton/DyButton';
// import LyBackdrop from '../Layouts/BackDrop/BackDrop';
// import CircularProgress from '@mui/material/CircularProgress';
// import { setUserPhoneNumberR } from '../Login/LoginSlice/LoginSlice';
// import { useState, useEffect } from 'react'
// import { useSelector } from 'react-redux';
// import { useLogin } from '../Login/Hooks/Index';
// import useWindowDimensions from '../DeviceSize/DeviceSize';
// import AndroidIcon from '@mui/icons-material/Android';
// import {ReactComponent as Omid} from '../Loading/svg/Om (1).svg';
// import DYToastMessage from '../GlobalComponents/DyToastMessage/DYToastMessage';
// import './Style.css';
// import SchoolIcon from '@mui/icons-material/School';
// import CreditCardIcon from '@mui/icons-material/CreditCard';
// import HandshakeIcon from '@mui/icons-material/Handshake';
// import SportsIcon from '@mui/icons-material/Sports';
// import NewspaperIcon from '@mui/icons-material/Newspaper';
// import CoPresentIcon from '@mui/icons-material/CoPresent';
// import Divider from '@mui/material/Divider';
// import { useDispatch } from 'react-redux';
// import {resetMeetingSliceR} from '../../scenes/Meeting/MeetingsSlice/MeetingsSlice'
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import InputAdornment from '@mui/material/InputAdornment';
// import IconButton from '@mui/material/IconButton';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
// import { node } from 'stylis';
// import { object } from 'yup';

// const LoginForm = ({ setContentState }: any) => {

//   const { width } = useWindowDimensions();
//   const [loginStatusLocal, setLoginStatusLocal] = useState<boolean | null>(null);
//   const [loginMessage, setLoginMessage] = useState<string | null>(null)
//   let authDevice = width > 900;

//   const loginStatus: any = useSelector((state: any) => state.loign.loginStatus);
//   const dispatch=useDispatch();
//   // const userInfo:any=useAppSelector(state=>state.loign.userInfo.userPhoneNumber)
//   const loginSuccess = () => {
//     // navigate('/dashboard',{replace:true})
//     // console.log(logdata)
//     // if (loginStatus?.hasOwnProperty('accessToken')) {
//     setContentState((prev: any) => ({ ...prev, content: 'userTypeSelection' }));
//     // }
//   }

//   useEffect(() => {

//     let initialValues={
//       priodId:'',
//       periodName:'',
//       meetingId:'',
//       profileTenantId:'',
//       teamId:'',
//       profileName:'',
//       periodList:[],
//       meetingsList:null,
//       teamsData:[],
//       teamInfo:{},
//       companyList:[],
//       teamList:[],
//       objectivie:[],
//       keyResults:[],
//       loading:false,
//       objUpdated:false,
//       changeTenantMode:false,
//       meetSelectedDate:'',
//       pictureBase64String:'',
//       treeViewState:{
//       treeView:true
//       }
//       ,
//       counter:0

//     }
//     dispatch(resetMeetingSliceR(initialValues))

//   }, )

//   const loginFailed = () => {

//   }
//   const { data: logdata, mutate: LoginReq, isLoading } = useLogin(loginSuccess, loginFailed)

//   const userBody = {
//     phoneNumber: "",
//     password: "",
//     smsCode: "",
//     isOTP: false
//   }

//   const initialValue = {
//     phoneNumber: '09198390527',
//     password: 'AriaBarbod'
//   }
//   const [userInfoState, setUserInfoState] = useState<any>(userBody || null);

//   // console.log(logdata)

//   const initialForgetPass = () => {
//     // console.log('runnn')
//     setContentState((prev: any) => ({ ...prev, content: 'forgetPassWord' }))
//   }

//   const loginHandler = () => {
//     LoginReq(userInfoState)

//     dispatch(setUserPhoneNumberR(userInfoState || ''))
//     // console.log(userInfoState)
//   }

//   useEffect(() => {
//     if (logdata) {
//       // console.log(logdata)
//       let { data: { isSuccess, data, metaData } }: any = logdata;
//       let { message }: any = metaData;
//       let logStatus = { success: isSuccess };
//       // console.log(message)
//       setLoginMessage(message);
//       // loginMessage,setLoginMessage
//       setLoginStatusLocal(!loginStatus)
//       // console.log(isSuccess, data)
//     }

//   }, [logdata])

//   const linkStyle = {
//     fontSize: '0.6rem'
//   }
//   const [showPassword, setShowPassword] = React.useState(false);

//   const handleClickShowPassword = () => setShowPassword((show) => !show);

//   const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
//     event.preventDefault();
//   };

//   if (!authDevice) {
//     return <Box width={'100%'} py={1} textAlign={'center'}  >

//       <Grid xs={12}   >
//         <Box width={'100%'}
//           display={'flex'}
//           justifyContent={'center'}
//           textAlign={'center'}
//           flexDirection={'column'}
//           rowGap={2}
//         >
//           <Box>
//             <Typography color={'red'} fontWeight={900} fontSize={'1.1rem'} >
//               لطفا از نسخه موبایل استفاده کنید
//             </Typography>
//           </Box>
//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none', }}
//                 rel='noopener noreferrer' href="https://mobile.myokr.ir/">
//                 <Typography color='primary' fontWeight={900} variant='h6'   >نسخه موبایل
//                   {/* <SchoolIcon   /> */}

//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <AndroidIcon color='primary' />
//             </Box>
//           </Box>

//           <Divider variant="middle" />

//           {/* <Typography  fontSize={'0.7rem'} fontWeight={600} color={'blue'}  > */}
//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none', }}
//                 rel='noopener noreferrer' href=" https://okrcoach.ir/okrcoach-software-online/installation/">
//                 <Typography color='primary'   > آموزش نرم افزار
//                   {/* <SchoolIcon   /> */}

//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <SchoolIcon color='primary' />
//             </Box>
//           </Box>

//           <Divider variant="middle" />

//           {/* ////////////////////// */}

//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none', }}
//                 rel='noopener noreferrer' href="https://okrcoach.ir/okrcoach-software-online/">
//                 <Typography color='primary'   > خرید اشتراک نرم افزار
//                   {/* <SchoolIcon   /> */}

//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <CreditCardIcon color='primary' />
//             </Box>
//           </Box>
//           <Divider variant="middle" />

//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none', }}
//                 rel='noopener noreferrer' href="https://okrcoach.ir/okr-coach/">
//                 <Typography color='primary'   > درخواست مربی
//                   {/* <SchoolIcon   /> */}

//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <SportsIcon color='primary' />
//             </Box>
//           </Box>

//           <Divider variant="middle" />

//           {/* ////////////////////// */}

//           {/* <a target='_blank'
//             style={{ textDecoration: 'none', }}
//             rel='noopener noreferrer' href="https://okrcoach.ir/customers/ "><Typography   >مشتریان ما<Box mt={'5px'}    >
//               <HandshakeIcon />
//             </Box>
//             </Typography>
//           </a> */}

//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none', }}
//                 rel='noopener noreferrer' href="https://okrcoach.ir/customers/">
//                 <Typography color='primary'   > مشتریان ما

//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <HandshakeIcon color='primary' />
//             </Box>
//           </Box>

//           <Divider variant="middle" />

//           {/* <a target='_blank'
//             style={{ textDecoration: 'none', }}
//             rel='noopener noreferrer' href=" https://okrcoach.ir/amir-imenpour/ "><Typography   >معرفی ما<Box mt={'5px'}    >
//               <CoPresentIcon />
//             </Box>
//             </Typography>
//           </a> */}

//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none' }}
//                 rel='noopener noreferrer' href="https://okrcoach.ir/amir-imenpour/">
//                 <Typography color='primary'   >معرفی ما

//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <CoPresentIcon color='primary' />
//             </Box>
//           </Box>

//           <Divider variant="middle" />

//           {/* <a target='_blank'
//             style={{ textDecoration: 'none', }}
//             rel='noopener noreferrer' href="https://okrcoach.ir/services/course/"><Typography   ><Box mt={'5px'}    >
//               <SchoolIcon />
//             </Box>
//             </Typography>
//           </a> */}

//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none' }}
//                 rel='noopener noreferrer' href="https://okrcoach.ir/services/course/">
//                 <Typography color='primary'   >آموزش OKR
//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <SchoolIcon color='primary' />
//             </Box>
//           </Box>

//           <Divider variant="middle" />

//           {/* <Box display={'flex'} alignItems={'center'}  >
//             <a target='_blank'
//               style={{ textDecoration: 'none', }}
//               rel='noopener noreferrer' href=" https://okrcoach.ir/okr-blog/">
//               <Typography>

//               </Typography>

//             </a>
//             <NewspaperIcon />
//           </Box> */}

//           <Box
//             width={'100%'}
//             display={'flex'}
//             justifyContent={'center'}
//             columnGap={1}
//             alignItems={'center'}
//           >
//             <Box mt={0.5}>
//               <a target='_blank'
//                 style={{ textDecoration: 'none' }}
//                 rel='noopener noreferrer' href="https://okrcoach.ir/okr-blog/">
//                 <Typography color='primary'   >مجله OKR
//                 </Typography>
//               </a>
//             </Box>
//             <Box>
//               <NewspaperIcon color='primary' />
//             </Box>
//           </Box>

//           <Divider variant="middle" />

//           {/* </Typography> */}

//         </Box>
//       </Grid>

//     </Box>
//   }

//   const initialChangePass=()=>{
//     setContentState((prev: any) => ({ ...prev, content: 'resetPassword' }))
//     console.log('initialChangePass')
//   }

//   const initialTenantRegister=()=>{
//     setContentState((prev: any) => ({ ...prev, content: 'registerTenant' }))
//     console.log('registerTenant')
//   }

//   const initialRegisterByCode=()=>{
//     setContentState((prev: any) => ({ ...prev, content: 'registerByCode' }))
//     console.log('registerByCode')
//   }

//   const initialRegisterTenant=()=>{
//     setContentState((prev: any) => ({ ...prev, content: 'RegisterTenant' }))
//     console.log('RegisterTenant')
//   }

//   if (isLoading) {
//     return <LyBackdrop visible={true}  >
//       <CircularProgress sx={{ color: 'white' }} />
//     </LyBackdrop>
//   }

//   return (
//     <Grid container display={'flex'}   justifyContent={'center'}  >
//    <Box width={'100%'} display={'flex'}   justifyContent={'center'} >
//   <Omid/>
//   </Box>
//       <Grid item xs={8}  mx={'auto'}  display={'flex'}   justifyContent={'center'}  borderRadius={4}  >
//         <Grid container rowGap={1}  >
//           <Grid item xs={12} >
//             <Typography fontSize={'18px'} fontWeight={600}>برای ورود شماره همراه خود را وارد کنید</Typography>
//           </Grid>

//           <Grid item xs={12}    >
//             <form autoComplete="off">
//               <Grid container  >
//                 <Grid item xs={12}   >
//                   <FormControl fullWidth>
//                     <DyTextField
//                       label={'شماره موبایل'}
//                       // Icon={<PhoneIcon/>}
//                       onchangee={setUserInfoState}
//                       value={userInfoState.phoneNumber || ''}
//                       name={'phoneNumber'}
//                       type={'text'}
//                     />
//                   </FormControl>
//                 </Grid>
// {/* 
//                 <Grid item xs={12}  py={3} >
//                   <FormControl fullWidth  >
//                     <DyTextField
//                       label={'رمز عبور'}
//                       // Icon={<KeyIcon/>}
//                       onchangee={setUserInfoState}
//                       value={userInfoState.password || ''}
//                       name={'password'}
//                       type={'password'}
//                     />
//                   </FormControl>
//                 </Grid> */}
                
//                 <Grid item xs={12}  py={3} >
//                 <FormControl fullWidth  >
//                 <DyTextField
//                       label={'رمز عبور'}
//                       onchangee={setUserInfoState}
//                       value={userInfoState.password || ''}
//                       name={'password'}
//                       type={showPassword ? 'text' : 'password'}
//                       />
//                       <InputAdornment position="end">
//                 <IconButton
//                   size='medium'
//                   color='primary'
//                   aria-label="toggle password visibility"
//                   onClick={handleClickShowPassword}
//                   onMouseDown={handleMouseDownPassword}
//                   edge="end"
//                 >
//                   {showPassword ? <VisibilityOff /> : <Visibility />}
//                 </IconButton>
//               </InputAdornment>
//                 </FormControl>
//                 </Grid>  
//              {/* <Grid item xs={12}  py={3} >
//                    <FormControl fullWidth variant="outlined">
//           <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
//           <OutlinedInput
//             id="outlined-adornment-password"
//             name={'password'}
//             value={userInfoState.password || ''}
//             size='small'
//             type={showPassword ? 'text' : 'password'}
//             endAdornment={
//               <InputAdornment position="end">
//                 <IconButton
//                   aria-label="toggle password visibility"
//                   onClick={handleClickShowPassword}
//                   onMouseDown={handleMouseDownPassword}
//                   edge="end"
//                 >
//                   {showPassword ? <VisibilityOff /> : <Visibility />}
//                 </IconButton>
//               </InputAdornment>
//             }
//             label="Password"
//           />
//         </FormControl>
//         </Grid>  */}

//                 {/* <Grid item xs={8} mx={'auto'} >
//                   <Box  >
//                     <DyButton
//                       caption={'ثبت نام با کد دعوت'}
//                       color={'#003287C'}
//                       onClick={initialRegisterByCode}
//                       variant={'text'}
//                       // bgColor={'#00347C'}
//                       // type={'submit'}
//                     />
//                   </Box>
//                 </Grid> */}
//                 {/* 00387C */}
//                 <Grid item xs={6}  mx={'auto'} >
//                   <Box py={1} gap={'30px'} display={'flex'} flexDirection={'row-reverse'} justifyContent={'start'}>
//                   <DyButton
//                       caption={'ثبت نام با کد دعوت'}
//                       onClick={initialRegisterByCode}
//                       variant={'contained'}
//                       bgColor={'#00387C'}
//                       color={'#fff'}
//                     />

//                     <DyButton
//                       caption={'ورود'}
//                       onClick={loginHandler}
//                       disbled={userInfoState.phoneNumber.length < 11}
//                       variant={'contained'}
//                       bgColor={'#00387C'}
//                       type={'submit'}
//                     />
//                      </Box>
//                 </Grid>
//                 <Grid item xs={12} >
//                   <Box py={2} display={'flex'} flexDirection={'row-reverse'} justifyContent={'end'}>
//                   <Box display={'flex'} flexDirection={'row-reverse'} justifyContent={'end'}>
//                   <DyButton
//                       caption={'فراموشی رمز عبور'}
//                       onClick={initialChangePass}
//                       variant={'text'}
//                       type={'submit'}
//                       // bgColor={'#00347C'}
//                       // type={'submit'}
//                     />
//                   </Box>
//                  </Box>

//                  <Divider variant="middle" />
//                 </Grid>
                
//                 <Grid item xs={12} mx={'auto'} >
//                   <Box width={'100%'}
//                     display={'flex'}
//                     justifyContent={'center'}
//                     textAlign={'center'}
//                     flexDirection={'row-reverse'}
//                     rowGap={1}
//                   >

//                     <Box display={'flex'} flexDirection={'row-reverse'} justifyContent={'space-between'}>
//                     <Box
//                        width={'100%'}
//                        display={'flex'}
//                        justifyContent={'center'}
//                        columnGap={1}
//                        alignItems={'center'}
//                     >
//                       <Box mt={0.5}>
//                         <a target='_blank'
//                           style={{ textDecoration: 'none', }}
//                           rel='noopener noreferrer' href=" https://okrcoach.ir/okrcoach-software-online/installation/">
//                           <Typography sx={linkStyle} color='primary'   > آموزش نرم افزار
//                           </Typography>
//                         </a>
//                       </Box>
//                       <Box>
//                         <SchoolIcon color='primary' />
//                       </Box>
//                     </Box>

//                     <Divider variant="middle" />
//                     <Box
//                       width={'100%'}
//                       display={'flex'}
//                       justifyContent={'center'}
//                       columnGap={1}
//                       alignItems={'center'}
//                     >
//                       <Box mt={0.5}>
//                         <a target='_blank'
//                           style={{ textDecoration: 'none' }}
//                           rel='noopener noreferrer' href="https://okrcoach.ir/okr-blog/">
//                           <Typography sx={linkStyle} color='primary'   >مجله OKR
//                           </Typography>
//                         </a>
//                       </Box>
//                       <Box>
//                         <NewspaperIcon color='primary' />
//                       </Box>
//                     </Box>

//                     </Box>
//                     <Divider variant="middle" />

//                     <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
//                     <Box
//                       width={'100%'}
//                       display={'flex'}
//                       justifyContent={'center'}
//                       columnGap={1}
//                       alignItems={'center'}
//                     >
//                       <Box mt={0.5}>
//                         <a target='_blank'
//                           style={{ textDecoration: 'none' }}
//                           rel='noopener noreferrer' href="https://okrcoach.ir/services/course/">
//                           <Typography sx={linkStyle} color='primary'   >آموزش OKR
//                           </Typography>
//                         </a>
//                       </Box>
//                       <Box>
//                         <SchoolIcon color='primary' />
//                       </Box>
//                     </Box>
//                     </Box>
//                     <Divider variant="middle" />
//                     <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
//                     <Box
//                       width={'100%'}
//                       display={'flex'}
//                       justifyContent={'center'}
//                       columnGap={1}
//                       alignItems={'center'}
//                     >
//                       <Box mt={0.5}>
//                         <a target='_blank'
//                           style={{ textDecoration: 'none' }}
//                           rel='noopener noreferrer' href="https://okrcoach.ir/amir-imenpour/">
//                           <Typography sx={linkStyle} color='primary'   >معرفی ما

//                           </Typography>
//                         </a>
//                       </Box>
//                       <Box>
//                         <CoPresentIcon color='primary' />
//                       </Box>
//                     </Box>
//                     </Box>
//                   </Box>
//                 </Grid>

//               </Grid>

//             </form>

//           </Grid>

//         </Grid>

//         {/* show,setShow} */}
//       </Grid>
//       {
//         loginStatusLocal && loginMessage &&
//         <DYToastMessage
//           show={!loginStatus}
//           setShow={setLoginStatusLocal}
//           message={loginMessage}
//         />
//       }

//     </Grid>
//   )
// }

// export default LoginForm
///////////////////////////////////////////////////////////////////////////
